import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

interface MyHrLoginTwoFactorRegisterWithQrCodeProps {
  data: { qrCode: string };
  setManualSetting: (value: boolean) => void;
}

export const MyHrLoginTwoFactorRegisterWithQrCode = ({
  data,
  setManualSetting,
}: MyHrLoginTwoFactorRegisterWithQrCodeProps) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Box sx={{ textAlign: "left", marginTop: "24px" }}>
        <Typography variant="body1">
          {t("MY_HR_SCAN_QR_WITH_AUTHENTICATOR_APP")}
        </Typography>
      </Box>
      <Box
        sx={{
          marginTop: "16px",
          marginBottom: "16px",
        }}
      >
        <img src={data.qrCode} alt="QR Code" />
      </Box>
      <Box
        sx={{ textAlign: "center", cursor: "pointer" }}
        onClick={() => setManualSetting(true)}
      >
        <Typography id="cannotScanQrCode" color="#CC0033" variant="body1">
          {t("MY_HR_CANNOT_SCAN_QR_CODE")}
        </Typography>
      </Box>
    </Box>
  );
};

export default MyHrLoginTwoFactorRegisterWithQrCode;
